export type RequestParams = {
  method: 'GET' | 'POST';
  headers?: HeadersInit;
  body?: BodyInit | null;
};

export function fetchData<T>(url: string, params: RequestParams): Promise<T> {
  return fetch(url, params).then((response) => {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return response.json() as Promise<T>;
  });
}
